import { NgModule } from '@angular/core';
import { NaPricePipe } from './na-price.pipe';
import { NaIsNullOrEmptyPipe } from './na-is-null-or-empty.pipe';
import { NaHighlightPipe } from './na-highlight.pipe';
import { NaDesensitizationPipe } from './na-desensitization.pipe';

const pipe = [
  NaDesensitizationPipe,
  NaHighlightPipe,
  NaPricePipe,
  NaIsNullOrEmptyPipe
];

@NgModule({
  exports: [
    ...pipe
  ],
  declarations: [
    // ç®¡éçæå¿é¡»æ¾å°declarationséé¢
    ...pipe
  ],
  providers: [
    ...pipe
  ]
})
export class NaPipeModule { }
